export default "__VITE_ASSET__Bur20EZV__"